<template>
  <div class="container" v-if="isLoggedIn">
    <!-- 서브상단영역 -->
    <Banner
      title="기관"
      subtitle="기관"
      description="학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>
        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    />

    <!-- //서브상단영역 -->

    <BoardNavbar />

    <!-- //서브상단영역 -->

    <div class="width_wrap">
      <div v-if="isOrgUser" class="body_content">
        <!-- 서브 타이틀영역 -->
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 1rem;
          "
        >
          <h1 class="sub_subject" style="margin-bottom: 0">
            [기관] Activity 기본정보<span></span>
          </h1>
          <router-link
            :to="{
              name: USER_ROUTES.Mypage.Order.Org.Request.Name,
              params: { pid: constant.OrderType.ACTIVITY },
            }"
            custom
            v-slot="{ navigate }"
          >
            <n-button type="primary" @click="navigate" role="link">
              신청서 작성
            </n-button>
          </router-link>
        </div>
        <!-- //서브 타이틀영역 -->
        <div class="title_description">
          초등학생 ‧ 중학생 ‧ 고등학생 ‧ 대학생
        </div>
        <div class="sub_description">
          ※ 소요 시간은 학교급별 1차시 시간(초-40분/중-45분/고*대-50분)에 맞춤
        </div>
        <br />
        <div>◰ Activity - 초등학생(✔)</div>
        <div class="sub1">
          <table class="st_mybd_list">
            <colgroup>
              <col style="width: 8%" />
              <col />
              <col style="width: 14%" />
              <col style="width: 14%" />
            </colgroup>
            <thead>
              <tr>
                <th scope="col">구분</th>
                <th scope="col">상품명</th>
                <th scope="col">소요시간</th>
                <th scope="col">가격(원)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td rowspan="3">초등학생<br />(고학년)</td>
                <td style="text-align: left; padding-left: 20px">
                  PUTT2.0기반 재능탐색_초등학생(고학년) : 진단(1시간) +
                  안내(0.5시간) + 활동 / 발표(2.5시간)
                </td>
                <td>4/1인 기준</td>
                <td>40,000 (PUTT2.0 포함)</td>
              </tr>
              <tr>
                <td style="text-align: left; padding-left: 20px">
                  꿈‧창업 프로젝트_초등학생(고학년) : 안내(1시간) + 활동 /
                  발표(2시간)
                </td>
                <td>3/1인 기준</td>
                <td>30,000</td>
              </tr>
              <tr>
                <td style="text-align: left; padding-left: 20px">
                  데이터사이언스 체험 활동_초등학생(6학년) : 안내(1시간) + 활동
                  / 발표(2시간)
                </td>
                <td>3/1인 기준</td>
                <td>30,000</td>
              </tr>
            </tbody>
          </table>
        </div>
        <br />
        <div>◰ Activity - 중학생(✔)</div>
        <div class="sub1">
          <table class="st_mybd_list">
            <colgroup>
              <col style="width: 8%" />
              <col />
              <col style="width: 14%" />
              <col style="width: 14%" />
            </colgroup>
            <thead>
              <tr>
                <th scope="col">구분</th>
                <th scope="col">상품명</th>
                <th scope="col">소요시간</th>
                <th scope="col">가격(원)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td rowspan="4">중학생</td>
                <td style="text-align: left; padding-left: 20px">
                  PUTT2.0기반 진로 탐색_중학생 + 진단(1시간) +
                  안내/활동/발표(3시간)
                </td>
                <td>4/1인 기준</td>
                <td>40,000 (PUTT2.0 포함)</td>
              </tr>
              <tr>
                <td style="text-align: left; padding-left: 20px">
                  꿈‧창업 프로젝트_중학생: 안내/ 활동/ 발표
                </td>
                <td>3/1인 기준</td>
                <td>30,000</td>
              </tr>
              <tr>
                <td style="text-align: left; padding-left: 20px">
                  데이터사이언스 체험 활동_중학생: 안내/ 활동/ 발표
                </td>
                <td>4/1인 기준</td>
                <td>30,000</td>
              </tr>

              <tr>
                <td style="text-align: left; padding-left: 20px">
                  성장-폴리오_중학생: 안내/ 활동/ 발표
                </td>
                <td>4/1인 기준</td>
                <td>30,000</td>
              </tr>
            </tbody>
          </table>
        </div>
        <br />
        <div>◰ Activity - 고등학생(✔)</div>
        <div class="sub1">
          <table class="st_mybd_list">
            <colgroup>
              <col style="width: 8%" />
              <col />
              <col style="width: 14%" />
              <col style="width: 14%" />
            </colgroup>
            <thead>
              <tr>
                <th scope="col">구분</th>
                <th scope="col">상품명</th>
                <th scope="col">소요시간</th>
                <th scope="col">가격(원)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td rowspan="4">고등학생</td>
                <td style="text-align: left; padding-left: 20px">
                  PUTT2.0기반 전공 탐색_고등학생 + 진단(1시간) +
                  안내/활동/발표(3시간)
                </td>
                <td>4/1인 기준</td>
                <td>40,000 (PUTT2.0 포함)</td>
              </tr>
              <tr>
                <td style="text-align: left; padding-left: 20px">
                  꿈‧창업 프로젝트_고등학생: 안내/ 활동/ 발표
                </td>
                <td>3/1인 기준</td>
                <td>30,000</td>
              </tr>
              <tr>
                <td style="text-align: left; padding-left: 20px">
                  데이터사이언스 체험 활동_고등학생: 안내/ 활동/ 발표
                </td>
                <td>4/1인 기준</td>
                <td>30,000</td>
              </tr>

              <tr>
                <td style="text-align: left; padding-left: 20px">
                  성장-폴리오_고등학생: 안내/ 활동/ 발표
                </td>
                <td>4/1인 기준</td>
                <td>30,000</td>
              </tr>
            </tbody>
          </table>
        </div>
        <br />
        <div>◰ Activity - 대학생‧예비전문가(✔)</div>
        <div class="sub1">
          <table class="st_mybd_list">
            <colgroup>
              <col style="width: 8%" />
              <col />
              <col style="width: 14%" />
              <col style="width: 14%" />
            </colgroup>
            <thead>
              <tr>
                <th scope="col">구분</th>
                <th scope="col">상품명</th>
                <th scope="col">소요시간</th>
                <th scope="col">가격(원)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td rowspan="3">대학생‧<br />예비전문가</td>
                <td style="text-align: left; padding-left: 20px">
                  PUTT2.0기반 직업 탐색_대학생 + 진단(1시간) +
                  안내/활동/발표(3시간)
                </td>
                <td>20분-30분 내외</td>
                <td>60,000/4/1 (PUTT2.0 포함)</td>
              </tr>
              <tr>
                <td style="text-align: left; padding-left: 20px">
                  데이터사이언스 체험 활동_대학생 : 안내/ 활동/ 발표
                </td>
                <td>20분-30분 내외</td>
                <td>60,000</td>
              </tr>
              <tr>
                <td style="text-align: left; padding-left: 20px">
                  성장-폴리오_대학생: 안내/ 활동/ 발표
                </td>
                <td>40분–50분 내외</td>
                <td>60,000</td>
              </tr>
            </tbody>
          </table>
        </div>
        <br />
        <div>◰ 결제 방법:계좌 이체</div>
        <div class="sub1">
          <table class="st_mybd_list">
            <colgroup>
              <col />
            </colgroup>
            <thead>
              <tr style="background-color: burlywood">
                <th scope="col">
                  우리은행 1005-104-783814, (예금주) 주식회사 코코랩
                </th>
              </tr>
            </thead>
          </table>
        </div>
        <div class="sub1">
          <router-link :to="`${USER_ROUTES.Price.Org.Path}`"
            >이 전
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import BoardNavbar from "@/views/business/Navbar.vue";
import Banner from "@/components/Banner.vue";
import { NIcon } from "naive-ui";
import { ChevronForward } from "@vicons/ionicons5";
import { watch } from "vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useRouter } from "vue-router";
import { useAuth } from "@/composables/useAuth";
import { useAlertDialog } from "@/composables/useAlert";
import * as constant from "@/constants/constant";
const useAlert = useAlertDialog();
const { isLoggedIn, isOrgUser } = useAuth();
const router = useRouter();
watch(
  isLoggedIn,
  async (newValue) => {
    if (newValue === false) {
      await useAlert("회원전용 페이지 입니다. 로그인 후 이용해주세요.");
      // TODO : 단순히 뒤로 갈지 향후 확인 후 변경 가능.
      // router.back();
      router.push({ name: USER_ROUTES.Home.Name });
    } else {
      if (!isOrgUser.value) {
        await useAlert("기관 사용자만 사용이 가능합니다.");
        router.push({ name: USER_ROUTES.Home.Name });
      }
    }
  },
  { immediate: true }
);
</script>

<style scoped>
.sub_title_01 p {
  position: absolute;
  top: 70px;
  left: 0;
  margin-top: -15px;

  width: 100%;
  font-size: 30px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 600;
}
.sub_title_01 h2 {
  position: absolute;
  top: 130px;
  left: 0;
  margin-top: -15px;

  width: 100%;
  font-size: 19px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 500;
  line-height: 1.7em;
}

.title_description {
  text-align: center;
  font-size: 16px;
  padding-top: 5px;
  padding-bottom: 5px;
  box-sizing: border-box;
  font-family: "Noto Sans", NanumGothic, "나눔고딕", "Open Sans", sans-serif;
  width: 100%;
  border-top: 2px solid #a5a5a5;
  border-bottom: 2px solid #a5a5a5;
  background: #fff;
}

.sub_description {
  text-align: right;
  font-size: 16px;
  padding-top: 5px;
  padding-bottom: 5px;
  box-sizing: border-box;
  font-family: "Noto Sans", NanumGothic, "나눔고딕", "Open Sans", sans-serif;
  width: 100%;
  border-top: none;
  border-bottom: none;
  background: #fff;
  color: red;
}

.sub1 * {
  box-sizing: border-box;
  font-family: "Noto Sans", NanumGothic, "나눔고딕", "Open Sans", sans-serif;
}
.st_cate_list_wrap {
  margin-bottom: 15px;
}
.st_cate_list_wrap .st_cate_list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.st_cate_list_wrap .st_cate_list li {
  width: 49%;
}
.st_cate_list_wrap .st_cate_list li a {
  display: block;
  padding: 10px 5px;
  border: 1px solid #ccc;
  background: #fff;
  font-size: 14px;
  color: #777;
  text-align: center;
}
.st_cate_list_wrap .st_cate_list li.on a,
.st_cate_list_wrap .st_cate_list li:hover a {
  border-color: #555555;
  color: #fff;
  background: #be7b42;
}

.sub1 > table {
  width: 100%;
  border-top: 2px solid #a5a5a5;
  background: #fff;
}
.sub1 > table caption {
  font-size: 18px;
  text-align: left;
  margin-bottom: 15px;
  font-weight: 500;
}
/* .sub1 > table tr:nth-child(even) {
    background: #f5f5f5;
} */
.sub1 > table th {
  position: relative;
  color: #333333;
  font-weight: 500;
  padding: 10px 5px; /* 상하 여백 줄임 */
  border-bottom: 1px solid #e4e4e4;
  border-right: 1px solid #e4e4e4;
}
.sub1 > table th:last-child {
  border-right: none;
}
.sub1 > table thead th {
  /* 헤더의 하단 경계선은 유지 */
  border-bottom: 1px solid #a5a5a5;
}
.sub1 > table th,
.sub1 > table td {
  font-size: 13px;
  line-height: 1.7em;
}
.sub1 > table td {
  padding: 1px 1px; /* 상하 여백 줄임 */
  /* border-top: 1px solid #e4e4e4; */ /* tr 사이 상단 경계선 제거 */
  color: #666666;
  text-align: center;
  border-bottom: none; /* tr 사이 하단 경계선 제거 */
  border-right: 1px solid #e4e4e4;
}
.sub1 > table td:last-child {
  border-right: none;
}
.sub1 > table td a {
  color: #666666;
}
.sub1 > table td a i {
  font-family: "Font Awesome 6 Free";
  font-size: 12px;
  padding-left: 5px;
}
.sub1 > table td a:hover {
  color: #444444;
  text-decoration: underline;
}
.sub1 > table tbody tr:last-child td {
  /* 테이블 바디의 마지막 행의 하단 경계선은 유지 (선택적) */
  border-bottom: 1px solid #e4e4e4;
}
.sub1 > table td[rowspan] {
  /* rowspan이 적용된 셀의 하단 테두리 표시 */
  border-bottom: 1px solid #e4e4e4;
}

.st_mybd_m_show_td {
  display: none;
}

.sub1 > a {
  border: 1px solid #ddd;
  padding: 8px 6px;
  display: block;
  width: 100px;
  margin: 40px auto 0 auto;
  text-align: center;
  font-size: 15px;
}
@media all and (min-width: 768px) {
  .sub1 > table {
    width: 100%;
  }
  .st_cate_list_wrap {
    margin-bottom: 60px;
  }
  .st_cate_list_wrap .st_cate_list {
    width: 60%;
    margin: 0 auto;
  }
  .st_cate_list_wrap .st_cate_list li a {
    font-size: 16px;
  }
  .sub1 > table th,
  .sub1 > table td {
    font-size: 15px;
  }
}

@media all and (min-width: 1024px) {
  .st_cate_list_wrap .st_cate_list {
    width: 50%;
  }
}
</style>
